var i="\nvoid addAmbient() {\n    dDiffuseLight += light_globalAmbient;\n}\n";export{i as default};
